<!--
Summit Logo     Home|Content Lib|Achievements                           User drop down

Summit Logo             Hamburger Menu
                            - Home
                            - Content Lib
                            - Achievements
                            - Account Information
                            - Sign out
-->

<script>
import { link, push, location } from 'svelte-spa-router';
import { curUser } from '../user.js'
import * as user from '../user.js'
import * as utils from '../utils';
import ModalLoading from './modals/loading.svelte';

let userState = 'no_session';
curUser.subscribe((u) =>
{
   if (u && u.auth)
   {
       userState = 'signed_in';
   }
   else
   {
       userState = 'no_session';
   }
});

let showMenu = false;
function CloseMenu()
{
    showMenu = false;
}

function ShowMenu()
{
    showMenu = true;
}


function Go(where)
{
    console.log('what am I doing?');
    CloseMenu();
    push(where);
}

function ToLitmos()
{
    ShowModal(ModalLoading, {}, (() => {}));

    user.ToLitmos();
}

const J = "javascript:void(0)";

</script>

<header id="summitHeader" class:menuVisible={showMenu}>
    <nav id="summitHeaderLeftNav">
        <ul>
            <li class="special"><a href="/"><img id="summitLogoSmall" src="images/blackLogoSmall.png" alt="Summit"/></a></li>
            <!--{#if userState === 'signed_in'}-->
            <!--    <li class="hide-left-nav-links"><a href={J} on:click={ToLitmos}>My Courses</a></li>-->
            <!--{/if}-->
        </ul>
    </nav>
    <nav id="summitHeaderRightNav">
        <ul class="hide-login">
          {#if userState === 'no_session'}
            <li><a href='/#/signin'>Sign In</a></li>
          {/if}
        </ul>
        <ul>
            <li class="special nav-special">
                <a href={"javascript:void(0)"} on:click={ShowMenu} class="icon solid fa-bars"></a>
                <div id="summitMenu">
                    <ul>
                        <li><a href={J} on:click={() => Go('/')}>Home</a></li>
                        <!--{#if userState === 'signed_in'}-->
                        <!--  <li class="hide-right-menu-links"><a href={J} on:click={user.ToLitmos}>My Courses</a></li>-->
                        <!--{/if}-->

                        {#if userState === 'no_session'}
                            <li class="hide-signin"><a href={J} on:click={() => Go('/signin')}>Sign In</a></li>
<!--                          <li><a href={J} on:click={() => Go('/signup/create')}>Sign Up</a></li>-->
                        {/if}

                        <li><a href={J} on:click={() => Go('/faculty')}>Faculty</a></li>
                        <li><a href={J} on:click={() => Go('/contact')}>Contact Us</a></li>

                        {#if userState === 'signed_in'}
                            <li><a href={J} on:click={() => Go('/signout')}>Sign Out</a></li>
                        {/if}
                    </ul>
                    <a href={J} on:click={CloseMenu} class="closer"></a>
                </div>
            </li>
        </ul>
    </nav>
</header>


<style>
#summitLogoSmall {
  max-height: 60px;
  vertical-align: middle;
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}

.closer {
  color: #1a242f !important;
}

li > a:hover, .closer:hover {
  color: #4c4c4c !important;
}

.nav-special {
  background-color: #1a242f;
  border: none;
  -moz-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  -ms-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

a.icon::before { color: #fff !important; }

.nav-special:visited, .nav-special:active {
  background-color: #1a242f;
}

#summitHeader *, #summitHeader *:before, #summitHeader *:after {
    box-sizing: inherit;
}

#summitHeader ul
{
    margin: 0;
}


#summitHeader, #summitNav
{
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
    vertical-align: baseline;
}

#summitHeader
{
    background: #fff;
    /*border-bottom: solid 1px #e2eaec;*/
    height: 4.75em;
    left: 0;
    line-height: 4.75em;
    top: 0;
    width: 100%;
    z-index: 10000;
  	position: fixed;
    box-sizing: border-box;
    /*-moz-box-shadow: 0 0.5px 5px 0px rgb(169, 169, 169, .3);
    -webkit-box-shadow: 0 0.5px 5px 0px rgb(169, 169, 169, .3);
    box-shadow: 0 0.5px 5px 0px rgb(169, 169, 169, .3);*/
    display: inline-flex;
}

#summitHeader h1
{
    color: #626c6e;
    font-weight: bold;
    letter-spacing: -0.05em;
    line-height: 1em;
    height: inherit;
    left: 1em;
    line-height: inherit;
    top: 0;
    margin:0;
}

#summitHeader h1 a {
    text-decoration: none;
    border: 0;
    font-size: 1.25em;
}

#summitHeader h1 a:before {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    text-transform: none !important;
    font-family: 'Font Awesome 5 Free';
    font-weight: 400;
}

#summitHeader h1 a.solid:before {
    font-weight: 900;
}

#summitHeader h1 a.brands:before {
    font-family: 'Font Awesome 5 Brands';
}

#summitHeader h1 a:before {
    color: #fff !important;
    text-shadow: 1px 0 0 #6ec7f5, -1px 0 0 #6ec7f5, 0 1px 0 #6ec7f5, 0 -1px 0 #6ec7f5;
}


#summitHeaderRightNav {
  flex-grow: 2;
  display: inline-flex;
  justify-content: flex-end;
}

#summitHeaderLeftNav
{
    flex-grow: 1;
    display: inline-flex;
}

#summitHeaderRightNav:after {
    clear: both;
    content: '';
    display: block;
}

#summitHeaderLeftNav:after {
    clear: both;
    content: '';
    display: block;
}

#summitHeader nav ul {
    list-style: none;
    padding: 0;
}

#summitHeaderLeftNav  ul li {
    display: block;
    float: left;
    padding: 0;
}

#summitHeader nav ul li > a, #summitHeader nav ul li > span {
    border: 0;
    color: #1c1d1e;
    display: block;
    font-weight: bold;
    padding: 0 1.5em;
}

#summitHeader nav ul li.special > .icon:before {
    color: #1c1d1e;
    margin-right: 0.5em;
}



#summitHeader ul.menu {
    list-style: none;
    padding: 0;
}

#summitHeader ul.menu li {
    border-left: solid 1px #e2eaec;
    display: inline-block;
    line-height: 1em;
    margin: 0 0 0 0.5em;
    padding: 0 0 0 0.5em;
}

#summitHeader ul.menu li:first-child {
    border-left: 0;
    margin-left: 0;
    padding-left: 0;
}

#summitMenu {
    -moz-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;
    -moz-transform: translateX(20em);
    -webkit-transform: translateX(20em);
    -ms-transform: translateX(20em);
    transform: translateX(20em);
    -moz-transition: -moz-transform 0.5s ease;
    -webkit-transition: -webkit-transform 0.5s ease;
    -ms-transition: -ms-transform 0.5s ease;
    transition: transform 0.5s ease;
    display: block;
    height: 100%;
    right: 0;
    overflow-y: auto;
    position: fixed;
    top: 0;
    width: 20em;
    z-index: 10002;
    background: #fff;
    border-left: solid 1px #e2eaec;
    box-shadow: 0 0 6px 0 rgba(20, 40, 64, 0.1);
    cursor: default;
    padding: 2.25em 1.5em;
}

.closer {
    text-decoration: none;
    display: block;
    height: 4em;
    overflow-x: hidden;
    position: absolute;
    right: 0;
    text-indent: 8em;
    top: 0;
    white-space: nowrap;
    width: 8em;
}
.closer:before {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    text-transform: none !important;
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
}

.closer:before {
    -moz-transition: color 0.2s ease-in-out;
    -webkit-transition: color 0.2s ease-in-out;
    -ms-transition: color 0.2s ease-in-out;
    transition: color 0.2s ease-in-out;
    color: #1c1d1e;
    content: '\f00d';
    display: block;
    height: 4em;
    line-height: 4em;
    position: absolute;
    right: 1.5em;
    text-align: center;
    text-indent: 0;
    top: 0;
}

.closer:hover:before {
    color: #6ec7f5;
}

#summitMenu h2 {
    font-size: 1.25em;
    margin: 0 0 0.5em 0;
}

#summitMenu a, #summitMenu span {
    border: 0;
    color: inherit;
}

#summitMenu ul {
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
}

#summitMenu ul li {
    padding: 0 0 0 1em;
}

#summitMenu ul li:before {
    background: #e2eaec;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    width: 100%;
}

#summitMenu ul li > a, #summitMenu ul li > span {
    display: block;
    line-height: 3.5em;
}

#summitMenu > ul > li {
    padding-left: 0;
}

#summitMenu > ul > li:first-child:before {
    display: none;
}

#summitMenu > ul > li > a, #summitMenu > ul > li > span {
    color: #626c6e;
}

#summitHeader.menuVisible #summitMenu {
    -moz-transform: translateX(0);
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
}

@media screen and (max-width: 1000px) {

    #summitHeader nav ul li.hideOn {
        display: none;
    }

}

@media screen and (max-width: 736px) {
  #summitHeader .hide-login {
      display: none;
  }
}

@media screen and (min-width: 737px) {
  #summitHeader .hide-signin {
    display: none;
  }
}

@media screen and (max-width: 980px) {
  .hide-left-nav-links {
    display: none !important;
  }
}

@media screen and (min-width: 981px) {
  .hide-right-menu-links {
    display: none !important;
  }
}


</style>
